import { render, staticRenderFns } from "./HeaderVideo.vue?vue&type=template&id=621d5d71&scoped=true&"
import script from "./HeaderVideo.vue?vue&type=script&lang=js&"
export * from "./HeaderVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeaderVideo.vue?vue&type=style&index=0&id=621d5d71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d5d71",
  null
  
)

export default component.exports